var parse = require('./lib/parse');

module.exports = function(config) {
    config = config || {};
    var UA = config.ua;
    var HOST = config.host;

    var isNode;
    try{
        isNode = Object.prototype.toString.call(global.process) === '[object process]';
    }catch(e){
        isNode = false
    }
    if (isNode) {
        UA = UA || this.req.headers['user-agent']
        HOST = HOST || this.req.headers['host'];
    }else{
        UA = UA || window.navigator.userAgent || window.navigator.vendor || window.opera;
        HOST = HOST || window.location.host
    }

    return parse(UA, HOST)
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/util-m-ua/index.js
// module id = 265
// module chunks = 0 8 9